import React, { useEffect } from "react";
import PropTypes from "prop-types";

import Analytics from "analytics/util/Analytics";
import OkInput from "shared/components/oknf/OkInput";
import Str from "shared/components/Str";
import Strf from "shared/components/Strf";
import _str from "shared/util/_str";
import getImagePath from "shared/util/getImagePath";

const EnterPromoCode = ({
	promoCode,
	onPromoCodeChange,
	onPromoCodeSubmit,
}) => {
	// Fire this only on mount.
	useEffect(() => {
		Analytics.logUIEvent(Analytics.eventNames.voucherViewedModal, {
			data: {
				voucher: promoCode,
			},
		});
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const submitOnEnterKeyDown = (event) => {
		if (event.key !== "Enter" || promoCode.length === 0) {
			return;
		}

		event.preventDefault();

		if (onPromoCodeSubmit) {
			onPromoCodeSubmit();
		}
	};

	return (
		<div className="voucherContents">
			<img className="voucherContents-box" src={`${getImagePath()}media/img/vouchers/NewFirstBox.png`} alt="voucher" />
			<Str className="voucherContents-header">Enter your promo code</Str>
			<Str className="voucherContents-sub">Unlock In-App Rewards</Str>
			<OkInput
				className="voucherContents-input"
				value={promoCode}
				onChange={onPromoCodeChange}
				onKeyDown={submitOnEnterKeyDown}
				placeholder={_str("Enter code here")}
			/>
			<Strf
				vars={{
					TERMS: (
						<a
							className="voucherContents-link"
							href="https://okcupid.com/legal/terms">
							<Str>Terms</Str>
						</a>
					),
					PRIVACY: (
						<a
							className="voucherContents-link"
							href="https://okcupid.com/legal/privacy">
							<Str>Privacy Policy</Str>
						</a>
					),
				}}
				className="voucherContents-terms">
				By submitting, you agree with our $TERMS & $PRIVACY.
			</Strf>
			<button
				type="submit"
				value="Submit"
				className="big blue flatbutton"
				onClick={onPromoCodeSubmit}
				disabled={promoCode.length === 0}
			>
				<Str>Submit</Str>
			</button>
		</div>
	);
};

EnterPromoCode.propTypes = {
	promoCode: PropTypes.string.isRequired,
	onPromoCodeChange: PropTypes.func.isRequired,
	onPromoCodeSubmit: PropTypes.func.isRequired,
};

export default EnterPromoCode;



// WEBPACK FOOTER //
// ./src/shared/components/VoucherModal/EnterPromoCode.jsx